<template>
  <div class="mt-7 ml-11">
    <div class="d-flex">
      <v-card style="display: inline-block;min-width: 280px;height: 420px">
        <div style="margin: 0 auto;width: 120px;padding-top: 45px;flex: none">
          <v-avatar
              width="120px"
              height="120px">
            <img :src="$store.state.avatar">
          </v-avatar>
          <v-btn
              @click="changeAvatar"
              width="100px"
              height="30px"
              outlined
              color="rgba(229, 229, 229, 1)"
              style="margin-top: 30px;margin-left:10px;font-size: 14px;">
            <p style="color: black">更改头像</p></v-btn>
          <div style="margin: 30px auto 0 auto;width: max-content">
            <span class="iconfontFamily" style="font-size: 20px;color: rgba(0, 0, 0, 1);float: left">&#xe623;</span>
            <div style="font-size: 16px;margin-left: 10px;float: left;line-height: 30px">{{$store.state.nickName}}</div>
          </div>
        </div>
      </v-card>
      <v-card style="display: inline-block;width: 1250px;min-width: 1250px;height: 420px;margin-left: 10px;padding-top: 18px;margin-right: 30px">
        <v-tabs @change="onTabChange" v-model="tabValue" light color="black" style="margin-left: 40px;width: 300px;">
          <v-tabs-slider color="rgba(30, 58, 138, 1)" style="height: 3px"></v-tabs-slider>
          <v-tab style="font-size: 16px;font-weight: 700">基本信息</v-tab>
          <v-tab style="font-size: 16px;font-weight: 700">修改密码</v-tab>
        </v-tabs>
        <div v-if="tabValue === 0"  style="position: relative;height: 70px;margin-left: 50px;margin-top: 55px">
            <div style="width: 900px;">
              <div style="position: relative;">
                <v-text-field
                        @blur="nickNameBlur"
                        v-model="nickName"
                        :readonly="edtBtn1 === '修改'"
                        :counter=" edtBtn1 === '修改'?false:10"
                        required>
                  <template v-slot:prepend>
                    <div style="height: 25px;line-height: 25px;font-size: 16px;margin-right: 55px;width: max-content;color: black">账号名称</div>
                  </template>
                  <template v-slot:append>
                    <div @click="editAccount" style="cursor: pointer;height: 20px;color: rgba(25, 118, 210, 1);">{{edtBtn1}}</div>
                  </template>
                </v-text-field>
                <div v-show="edtBtn1 === '修改'" style="width: 772px;height: 2px;background-color: rgba(204,204,204,1);bottom: 21px;position: absolute;right: 0"></div>
              </div>
              <div style="position: relative;">
                <v-text-field
                        @blur="introduceBlur"
                        v-model="$store.state.introduce"
                        :readonly="edtBtn2 === '修改'"
                        :counter=" edtBtn2 === '修改'?false:50"
                        required>
                  <template v-slot:prepend>
                    <div  style="height: 25px;line-height: 25px;font-size: 16px;margin-right: 55px;width: max-content;color: black">账号介绍</div>
                  </template>
                  <template v-slot:append>
                    <div @click="editIntroduce" style="cursor: pointer;height: 20px;color: rgba(25, 118, 210, 1);">{{edtBtn2}}</div>
                  </template>
                </v-text-field>
                <div  v-show="edtBtn2 === '修改'" style="width: 772px;height: 2px;background-color:rgba(204,204,204,1);bottom: 21px;position: absolute;right: 0"></div>
              </div>
              <div style="position: relative;">
                <v-text-field
                        v-model="$store.state.email"
                        :readonly="edtBtn3 === '修改'"
                        required>
                  <template v-slot:prepend>
                    <div style="height: 25px;line-height: 25px;font-size: 16px;margin-right: 55px;width: max-content;color: black">登录邮箱</div>
                  </template>
                  <template v-slot:append>
                    <div @click="editEmail" style="cursor: pointer;height: 20px;color: rgba(25, 118, 210, 1);">{{edtBtn3}}</div>
                  </template>
                </v-text-field>
                <div style="width:  772px;height: 2px;background-color:rgba(204,204,204,1);bottom: 21px;position: absolute;right: 0"></div>
              </div>
              <!--修改邮箱弹窗-->
              <v-dialog
                  persistent
                  v-model="editEmailDialogCtl"
                  v-if="editEmailDialogCtl"
                  width="400"
              >
                <v-card v-if="modifyEmailStep === 1" class="pl-4 pt-4" style="height: 350px;position: relative">
                  <div @click="closeChangeEmailDialog" style="cursor: pointer;position: absolute;right: 27px;top: 27px;width: max-content"><span class="iconfontFamily" style="font-size: 15px;color: rgba(166, 166, 166, 1);">&#xe60d;</span></div>
                  <v-card-title class="text-h6" >
                    修改登录邮箱
                  </v-card-title>
                  <div style="font-size: 14px" class="ml-6 mt-3">
                    请输入登录密码验证身份
                  </div>
                  <div style="width: 280px;height: 90px;margin: 30px auto 0 auto">
                    <v-text-field
                        placeholder="请输入创作平台密码"
                        v-model="modifyEmailPassword"
                        type="password"
                        class="input-group--focused">
                      <template  v-slot:message style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;密码不能为空</template>
                    </v-text-field>
                    <div v-show="passwordError" style="height: 30px;margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>密码不正确，请重新输入</div>
                  </div>
<!--                  <div style="width: 280px;margin: 30px auto 0 auto">-->
<!--                    <input v-model="modifyEmailPassword" type="password" style="border: none;outline: none;width: 280px;height: 30px" placeholder="请输入创作平台密码">-->
<!--                    <v-divider style="width: 280px"></v-divider>-->
<!--                    <div v-show="true" style="margin-top: 6px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>密码不正确，请重新输入</div>-->
<!--                  </div>-->
                  <v-btn
                      @click="verifyMailPassword"
                      width="80px"
                      height="30px"
                      depressed
                      :color="modifyEmailPassword.length>0?'rgba(30, 58, 138, 1)':'rgba(143, 157, 197, 1)'"
                      style="position: absolute;bottom: 60px;right: 60px;color: white;font-size: 16px">
                    下一步</v-btn>
                </v-card>
                <v-card v-if="modifyEmailStep === 2" class="pl-4 pt-4" style="height: 350px;position: relative">
                  <div @click="closeChangeEmailDialog" style="cursor: pointer;position: absolute;right: 27px;top: 27px;width: max-content"><span class="iconfontFamily" style="cursor: pointer;font-size: 15px;color: rgba(166, 166, 166, 1);">&#xe60d;</span></div>
                  <v-card-title class="text-h6" >
                    修改登录邮箱
                  </v-card-title>
                  <div style="font-size: 14px" class="ml-6 mt-3">
                    已将验证码发送至邮箱{{$store.state.email}}
                  </div>
                  <div style="width: 280px;height: 90px;margin: 30px auto 0 auto">
                    <v-text-field
                        placeholder="请输入邮箱验证码"
                        v-model="modifyEmailVerifyCode1"
                        class="input-group--focused">
                      <template  v-slot:message style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;验证码不能为空</template>
                    </v-text-field>
                    <div v-show="modifyEmailVerifyCode1Error" style="height: 30px;margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>验证码不正确，请重新输入</div>
                  </div>
                  <div @click="sendEmailForModifyEmail" class="ml-6" style="cursor: pointer;line-height: 30px;font-size: 14px" :style="{color:sendingAvailable?'rgba(25, 118, 210, 1)':'rgba(166, 166, 166, 1)'}"><span style="color: black">没有收到，请尝试</span> {{sendCodeContent === '获取验证码'?'重新发送':sendCodeContent}}</div>
                  <v-btn
                      @click="verifyEmailCode1ForChangeEmail"
                      width="80px"
                      height="30px"
                      depressed
                      :color="modifyEmailVerifyCode1.length>0?'rgba(30, 58, 138, 1)':'rgba(143, 157, 197, 1)'"
                      style="position: absolute;bottom: 60px;right: 60px;color: white;font-size: 16px">
                    下一步</v-btn>
                </v-card>
                <v-card v-show="modifyEmailStep === 3" class="pl-4 pt-4" style="height: 350px;position: relative">
                  <div @click="closeChangeEmailDialog" style="cursor: pointer;position: absolute;right: 27px;top: 27px;width: max-content"><span class="iconfontFamily" style="cursor: pointer;font-size: 15px;color: rgba(166, 166, 166, 1);">&#xe60d;</span></div>
                  <v-card-title class="text-h6" >
                    修改登录邮箱
                  </v-card-title>
                  <div style="font-size: 14px" class="ml-6 mt-3">
                    请输入新邮箱与邮箱验证码，修改后请使用新邮箱登录
                  </div>
                  <div style="width: 280px;margin: 10px auto 0 auto">
                    <v-text-field
                        placeholder="新邮箱账号"
                        v-model="newEmail"
                        :rules="emailRules"
                        class="input-group--focused">
                      <template  v-slot:message style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;请输入正确的邮箱格式</template>
                    </v-text-field>
                    <div v-show="emailOccupied" style="height: 30px;margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>该邮箱已注册</div>
                    <div v-show="!emailOccupied" style="height: 30px;margin-top: -16px;"></div>
                    <v-text-field
                        placeholder="邮箱验证码"
                        v-model="modifyEmailVerifyCode2"
                        :rules="requiredRule"
                        class="input-group--focused">
                      <template v-slot:append>
                        <div @click="sendEmailForModifyEmail2" style="width: max-content;cursor: pointer;line-height: 30px" :style="{color:sendingAvailable?'rgba(25, 118, 210, 1)':'rgba(166, 166, 166, 1)'}">{{sendCodeContent}}</div>
                      </template>
                      <template  v-slot:message style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;验证码不能为空</template>
                    </v-text-field>
                    <div v-show="modifyEmailVerifyCode2Error" style="height: 30px;margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>验证码不正确，请重新输入</div>
                  </div>
                  <v-btn
                      @click="verifyEmailCode2ForChangeEmail"
                      width="80px"
                      height="30px"
                      depressed
                      :color="modifyEmailVerifyCode2.length>0 &&newEmail.length > 0?'rgba(30, 58, 138, 1)':'rgba(143, 157, 197, 1)'"
                      style="position: absolute;bottom: 60px;right: 60px;color: white;font-size: 16px">
                    确认</v-btn>
                </v-card>
              </v-dialog>
            </div>
        </div>
        <div v-if="tabValue === 1">
            <!--二维码页-->
            <div v-show="changePasswordPage === 1">
              <div style="width: 180px;height: 180px;margin: 37px auto 35px auto;">
              <div v-show="!$store.state.appBound">
              </div>
              <div v-show="$store.state.appBound" style="position: relative">
                <!--二维码-->
                <div ref="qrCode" style="width: 180px;height: 180px;position: absolute;"></div>
                <!--扫码成功蒙层-->
                <div v-show="scanSuccess" style="position: absolute;width: 180px;height: 180px;background-color: rgba(255, 255, 255, 0.95);display: flex;align-items: center;justify-content: center;">
                  <div style="width: max-content;height: 40px">
                    <span class="iconfontFamily" style="font-size: 40px;color: rgba(67, 207, 124, 1);float: left;line-height: 40px">&#xe602;</span>     <div style="font-size: 20px;color: rgba(67, 207, 124, 1);line-height: 40px;float: left;margin-left: 5px">扫码成功</div>
                  </div>
                </div>
                <!--二维码失效蒙层-->
                <div v-show="qrCodeExpired" style="position: absolute;width: 180px;height: 180px;background-color: rgba(255, 255, 255, 0.95);display: flex;align-items: center;justify-content: center;">
                  <div style="width: max-content;height: 40px">
                    <div style="font-size: 16px;line-height: 40px;margin-left: 5px">二维码已过期</div>
                    <div @click="generateQRCode" style="font-size: 16px;line-height: 40px;margin: 0 auto;width: max-content;color: rgba(25, 118, 210, 1);cursor: pointer">点击刷新</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--设置新密码页-->
          <div v-show="changePasswordPage === 2" style="width: 280px;margin: 30px auto 0 auto">
            <v-form ref="newPasswordForm"
                    v-model="isNewPasswordValid">
              <v-text-field
                  placeholder="请输入新密码"
                  v-model="newPassword"
                  :rules="passwordRules"
                  :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showNewPassword ? 'text' : 'password'"
                  class="input-group--focused"
                  @click:append="showNewPassword = !showNewPassword">
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;密码为6-16个字符，且包含数字和字母及特殊字符</div>
                </template>
              </v-text-field>
              <v-text-field
                  placeholder="确认输入新密码"
                  v-model="newPassword2"
                  :rules="password2Rules"
                  :append-icon="showNewPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showNewPassword2 ? 'text' : 'password'"
                  class="input-group--focused"
                  @click:append="showNewPassword2 = !showNewPassword2">
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;两次密码不一致</div>
                </template>
              </v-text-field>
            </v-form>
            <v-btn
                @click="setNewPassword"
                width="280px"
                height="40px"
                depressed
                :color=" isNewPasswordValid? 'rgba(25, 118, 210, 1)': 'rgba(25, 118, 210, 0.5)'"
                style="left: 50%;transform: translateX(-50%);margin-top: 60px;color: white;font-size: 16px">
              保存</v-btn>
          </div>
          <!--密码修改成功页-->
          <div v-show="changePasswordPage === 3">
            <div style="width: max-content;height: 40px;margin: 135px auto 0 auto">
              <span class="iconfontFamily" style="font-size: 40px;color: rgba(67, 207, 124, 1);float: left;line-height: 40px">&#xe602;</span>     <div style="font-size: 20px;color: rgba(67, 207, 124, 1);line-height: 40px;float: left;margin-left: 5px">密码修改成功</div>
            </div>
          </div>
          <!--邮箱验证码页-->
          <div v-show="changePasswordPage === 4" style="width: 280px;margin: 90px auto 0 auto">
            <v-text-field
                placeholder="请输入邮箱验证码"
                @focus="mailVerifyCodeErrorForModifyPassword = false"
              v-model="emailVerifyCode"
              class="input-group--focused"
              :rules="requiredRule">
              <template  v-slot:message style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;验证码不能为空</template>
              <template v-slot:append>
                <div  @click="sendEmailForModifyPassword" style="width: max-content;cursor: pointer;line-height: 30px" :style="{color:sendingAvailable?'rgba(25, 118, 210, 1)':'rgba(166, 166, 166, 1)'}">{{sendCodeContent}}</div>
              </template>
            </v-text-field>
            <div v-show="mailVerifyCodeErrorForModifyPassword" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>验证码不正确，请重新输入</div>

            <v-btn
                @click="verifyEmailCode"
                width="280px"
                height="40px"
                depressed
                :color="emailVerifyCode.length>0? 'rgba(25, 118, 210, 1)': 'rgba(25, 118, 210, 0.5)'"
                style="left: 50%;transform: translateX(-50%);margin-top: 60px;color: white;font-size: 16px">
              下一步</v-btn>
          </div>
          <div v-show="$store.state.appBound&&changePasswordPage === 1" style="color:rgba(166, 166, 166, 1);font-size: 14px;width: max-content;margin: 20px auto 0 auto">{{qrHintText}}</div>

        </div>
      </v-card>
    </div>
    <v-card style="width: 1540px;min-width: 1540px;height: 400px;margin-top: 10px;">
      <div style="color: black;font-size: 16px;font-weight: 700;min-width: 260px" class="ml-8 pt-8">共生地球APP账号绑定<span style="color: rgba(229, 229, 229, 1)">（人员设置）</span></div>
      <div v-for="item in boundUserList" :key='item.phoneNum' class="ml-15 mt-10" style="min-width: 210px">
        <div  class="d-flex">
          <div style="text-align: right;width: 80px">手机账号：</div>
          <div class="ml-2">{{item.phoneNum}}</div>
          <div @click="$refs.bindAppDialog.openBindAppDialog()" v-show="!$store.state.appBound" class="ml-2" style="text-align: left;color: rgb(1, 25, 118, 210);font-size: 16px;cursor: pointer">绑定</div>
        </div>
        <div class="d-flex mt-6">
          <div style="text-align: right;width: 80px">昵称：</div>
          <div class="ml-2">{{item.userName}}</div>
          <div v-show="!$store.state.appBound" class="ml-2" style="text-align: left;font-size: 16px">-</div>

        </div>
      </div>
    </v-card>
    <v-dialog v-if="editAvatarDialogCtl"
        persistent
        v-model="editAvatarDialogCtl"
        width="600">
      <v-card style="height: 700px;width: 600px">
        <div style="height: 70px;width: 100%;box-shadow: 0 2px 7px 0 rgba(166, 166, 166, 0.25);line-height: 70px;position: relative" >
          <div style="position: absolute;left: 40px;line-height: 70px;font-size: 20px;font-weight: 700;">修改头像</div>
          <span @click="closeAvatarDialog" class="iconfontFamily" style="cursor: pointer;font-size: 12px;color: rgba(0, 0, 0, 1);position: absolute;right: 40px">&#xe60d;</span>
        </div>
        <div style="width: 100%;height: 74px;position: relative">
          <div v-show="showChangeAvatarErrorMsg" style="height: 30px;width: 100%;background-color: rgba(252, 165, 10, 1);color: white;font-size: 16px;text-align: center;line-height: 30px">{{changeAvatarErrorMsg}}</div>
          <div style="font-size: 14px;color: rgba(166, 166, 166, 1);position: absolute;left: 140px;bottom: 0">图片大小不超过5M</div>
        </div>
        <div style="width: 100px;height: 30px;margin-left: 140px;margin-top: 16px;cursor: pointer;">
          <label for="file">
            <div  style="cursor: pointer;width: 100px;height: 30px;border-radius: 4px;border: 1px solid rgba(229, 229, 229, 1);position: relative;text-align: center;font-size: 14px;line-height: 30px;background-color: white" class="mt-3">
              选择图片
            </div>
            <input ref="file" type="file" accept="image/jpg,image/png,image/jpeg"  id="file" style="display: none;" @change="getFileData">
          </label>
        </div>
        <div style="width: 320px;height: 240px;background-color:rgba(229, 229, 229, 1);margin: 56px auto 0 auto">
          <vueCropper
              v-if="imageFile !== ''"
              id="cropper"
              ref="cropper"
              :img="imageFile"
              :outputType="options.outputType"
              :auto-crop="true"
              :auto-crop-width="options.autoCropWidth"
              :auto-crop-height="options.autoCropHeight"
              :full="true"
              :height="true"
              :centerBox="false"
          >
            <template v-slot:>
              <div style="width: 100px;height: 100px;background-color: red">

              </div>
            </template>
          </vueCropper>
        </div>
        <v-btn
            @click="confirmChangeAvatar"
            width="100px"
            height="35px"
            depressed
            :color="imageFile !== ''?'rgba(30, 58, 138, 1)':'rgba(30, 58, 138, 0.5)'"
            style="position: absolute;bottom: 48px;left: 50%;transform: translateX(-50%);color: white;font-size: 14px">
          确定修改</v-btn>
      </v-card>
    </v-dialog>
    <Vcode :show="showPicVerify" @success="onPicVerifySuccess" @close="closePicVerify" successText="验证成功！"
           failText="验证失败，请重试！"/>
    <bind-app-dialog ref="bindAppDialog"></bind-app-dialog>
  </div>
</template>

<script>

import { VueCropper }  from 'vue-cropper'
import QRCode from "qrcodejs2";
import Vcode from "vue-puzzle-vcode";
import BindAppDialog from "@/views/user_system/bindAppDialog";
import utils from "@/utils/utils";

export default {
  name: "MainUserCenter",
  components: {
    BindAppDialog,
    Vcode,
    VueCropper
  },
  data(){
    return {
      nickName:'',
      tabValue:0,
      tempNickName:'',
      tempIntroduce:'',
      email:'',
      cropperImageBase64:'',
      edtBtn1:'修改',
      edtBtn2:'修改',
      edtBtn3:'修改',
      password:'',
      modifyEmailPassword:'',
      modifyEmailVerifyCode1:'',
      modifyEmailVerifyCode2:'',
      modifyEmailVerifyCode1Error:false,
      modifyEmailVerifyCode2Error:false,
      newEmail:'',
      btnFlag:false,
      imageFile:'',
      showChangeAvatarErrorMsg:false,
      changeAvatarErrorMsg:'文件大小不能超过5M',
      showPassword:false,
      step:1,
      editAvatarDialogCtl:false,
      editEmailDialogCtl:false,
      emailOccupied:false,
      modifyEmailStep:1,
      passwordError:false,
      // 1：扫码 2：邮箱
      changePasswordPage:1,
      qrHintText:'请通过共生地球绑定账户扫码进行后续操作',
      scanSuccess:false,
      qrCodeExpired:false,
      isNewPasswordValid:true,
      newPassword:'',
      newPassword2:'',
      showNewPassword:false,
      showNewPassword2:false,
      ///验证码倒计时
      sendingAvailable:true,
      countDownNum:60,
      sendCodeContent:'获取验证码',
      emailVerifyCode:'',
      showPicCount:0,
      showPicVerify: false,
      picVerifySuccess:false,
      mailVerifyCodeErrorForModifyPassword:false,
      clock:null,
      //裁剪图片
      options: {
        outputType: 'png',  // 需要剪裁的图片
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 240, // 默认生成截图框的宽度
        autoCropHeight: 240, // 默认生成截图框的长度
      },
      boundUserList:[],
      requiredRule:[
        v => !!v || 'E-mail is required',
      ],
      passwordRules:utils.passwordRules,
      password2Rules:[
        v => !!v || 'Name is required',
        v => (v && v === this.newPassword ) || "1"
      ],
      emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  methods:{
    setNewPassword(){
      if(!this.isNewPasswordValid){
        return
      }
      // 修改密码
      this.$axios.get('/userApi/creator/updatePassword',{
        params:{
          "email":this.$store.state.email,
          "password":this.newPassword
        }
      }).then(
          (resultData)=>{
            let _this = this
            if(resultData.data.code === 200){
              this.changePasswordPage = 3
              setTimeout(function () {
                _this.tabValue = 0
                _this.changePasswordPage = 1
              },1000);
            }
          }
      )
    },
    getUserInfo(){
      this.$axios({
        method:"get",
        url:"/authorApi/personal-data/getPersonalData",
      }).then((resultData)=>{
        resultData = resultData.data;
        this.boundUserList = []
        this.boundUserList.push({
          'phoneNum':resultData.data.appPhone,
          'userName':resultData.data.appUserName
        })

        if(resultData.status === 200){
          this.$store.commit('setUserid',resultData.data.userId)
          this.$store.commit('setNickName',resultData.data.nickName)
          this.$store.commit('setIntroduce',resultData.data.introduce)
          this.$store.commit('setAvatar',resultData.data.picture)
          this.nickName = this.$store.state.nickName
          this.tempNickName= this.$store.state.nickName
          this.tempIntroduce= this.$store.state.introduce
        }
      })
    },
    closeChangeEmailDialog(){
      this.editEmailDialogCtl = false
      this.modifyEmailPassword = ''
      this.emailOccupied = false
      this.passwordError = false
      this.modifyEmailVerifyCode1 = ''
      this.modifyEmailVerifyCode1Error = false
      this.newEmail = ''
      this.modifyEmailVerifyCode2 = ''
      this.modifyEmailVerifyCode2Error = false
      this.sendingAvailable = true;
      window.clearInterval(this.clock); //关闭
      this.countDownNum = 60;
    },
    getFileData() {
      this.showChangeAvatarErrorMsg = false
      let that = this
      if(this.$refs.file.files.length<1){
        return;
      }
      let file = this.$refs.file.files[0];//图片文件名
      if(file.type !== 'image/png'&&file.type !== 'image/jpg'&&file.type !== 'image/jpeg'){
        this.changeAvatarErrorMsg = '文件必须为以下格式：jpg、jpeg、png'
        this.showChangeAvatarErrorMsg = true
        setTimeout(function () {
          that.showChangeAvatarErrorMsg = false
        },1000);
        return;
      }
      if(file.size>1024*1024*5){
        this.changeAvatarErrorMsg = '文件大小不能超过5M'
        this.showChangeAvatarErrorMsg = true
        this.$refs.file.value = ''
        setTimeout(function () {
          that.showChangeAvatarErrorMsg = false
        },1000);
        return
      }
      if (!window.FileReader) return; // 看是否支持FileReader
      let reader = new FileReader();
      reader.readAsDataURL(file); // 关键一步，在这里转换的
      reader.onloadend = function () {
        that.imageFile = this.result;//赋值
      }
      this.$refs.file.value = ''
    },
    changeAvatar(){
      this.showChangeAvatarErrorMsg = false
      this.editAvatarDialogCtl = true
    },
    closeAvatarDialog(){
      this.editAvatarDialogCtl = false
      this.imageFile = ''
    },
    confirmChangeAvatar(){
      this.$refs.cropper.getCropData(async data => {
        //data是图片的base64编码
        let file = this.dataURLtoBlob(data,'avatar.png')
        let paramData = new FormData();
        paramData.append('multipartFile', file);
       let resultData = await this.$axios.post('/managerApi/upoladFile/uploadPiture', paramData)
        resultData = resultData.data;
        if (resultData.status === 200) {
          this.imageFile = resultData.data.picture.replace("https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/", "/huaweicloud");
          let res = await this.modifyInfo(resultData.data.picture,'','')
          if(res.status === 200){
            this.$store.commit('setAvatar',resultData.data.picture)
            this.editAvatarDialogCtl = false
            this.imageFile = ''
          }
        }
      })
    },
    async verifyMailPassword() {
      this.passwordError = false
      let resultData = await this.$axios.get('/userApi/creator/verifyPassword', {
        params: {'password': this.modifyEmailPassword}
      })
      if (resultData.data.code === 200) {
        this.modifyEmailStep = 2
        window.clearInterval(this.clock); //关闭
        this.countDownNum = 60;
        this.sendEmailForModifyEmail()
      }else{
        this.passwordError = true
      }
    },
    async modifyInfo(picture,nickname,introduce) {
      let formData = new FormData()
      formData.append('picture',picture)
      formData.append('nickName',nickname)
      formData.append('introduce',introduce)
      let response = await this.$axios.post('/authorApi/personal-data/modifyPersonalData', formData)
      return response.data
    },
    dataURLtoBlob(base64, name) {
      let arr = base64.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, {
        type: mime
      });
    },
    editAccount(){
      if(this.edtBtn1 === '修改'){
        this.edtBtn1 = "保存"
        this.tempNickName = this.$store.state.nickName
      }else if(this.edtBtn1 === '保存'&&this.nickName.length<=10 && this.nickName.length>0){
        this.edtBtn1 = "修改"
         this.modifyInfo('',this.nickName,'')
          this.$store.commit('setNickName',this.nickName)
          this.tempNickName = this.nickName
      }
    },
    nickNameBlur(){
      this.nickName = this.tempNickName
      this.edtBtn1 = "修改"
    },
    editIntroduce(){
      if(this.edtBtn2 === '修改'){
        this.edtBtn2 = "保存"
        this.tempIntroduce= this.$store.state.introduce
      }else if(this.edtBtn2 === '保存'&&this.$store.state.introduce.length<=50){
        this.edtBtn2 = "修改"
        this.modifyInfo('','',this.$store.state.introduce)
        // this.$store.commit('setIntroduce',this.$store.state.introduce)
        this.tempIntroduce = this.$store.state.introduce
      }
    },
    introduceBlur(){
      this.$store.commit('setIntroduce',this.tempIntroduce)
      this.edtBtn2 = "修改"
    },
    editEmail(){
      if(this.edtBtn3 === '修改'){
        this.editEmailDialogCtl= true
        this.modifyEmailStep = 1
      }else{
        this.edtBtn3 = "修改"
      }
    },
    onTabChange(){
      if(this.tabValue === 1){
        if(this.$store.state.appBound){
          this.changePasswordPage = 1
          this.generateQRCode()
        }else{
          this.changePasswordPage = 4
          this.emailVerifyCode = ''
          this.mailVerifyCodeErrorForModifyPassword = false
          this.newEmail = ''
          this.newPassword = ''
          this.newPassword2 = ''
          window.clearInterval(this.clock);
          clearTimeout(this.isValidTimer)
          clearInterval(this.queryTimer)//关闭
          this.sendingAvailable = true;
          this.countDownNum = 60;
          this.sendCodeContent = "获取验证码"
        }
      }
    },
    async generateQRCode(){
      // 初始化timer
      this.qrCodeExpired = false
      this.scanSuccess = false
      if(this.queryTimer){
        clearInterval(this.queryTimer)
        this.queryTimer = null
      }
      if(this.isValidTimer){
        clearTimeout(this.isValidTimer)
        this.isValidTimer = null
      }
      // 拉取二维码字符串
      let resultData = await this.$axios.get('/userApi/creator/getQRCodeLogin',{
        params:{'purpose':'modifyPassword'}
      })

      let code = {
        'type':'CodeScanType.changeAuthorPassword',
        'content':resultData.data.data
      }
      if(resultData.data.code === 200){
        //清除二维码方法一
        this.$refs.qrCode.innerHTML = '';
        new QRCode(this.$refs.qrCode, {
          //二维码内容
          text: JSON.stringify(code),
          width: 180,
          height: 180,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
      if(resultData.data.code === 200){
        // 轮询APP扫码状态
        this.queryTimer = setInterval(() => {
          this.$axios.get('/userApi/creator/checkQRCodeStatus',{
            params:{
              'QRCode':resultData.data.data
            }
          }).then(
              (resultData)=>{
                if(resultData.data.data.status === 1){
                  this.scanSuccess = true
                  this.qrHintText = '请在共生地球APP中进行确认'
                  clearTimeout(this.isValidTimer)
                }else if(resultData.data.data.status === 3){
                  clearTimeout(this.isValidTimer)
                  clearInterval(this.queryTimer)
                  this.changePasswordPage = 2
                }
              })
        },1000);
        // 设置5分钟后二维码失效
        this.isValidTimer = window.setInterval(() => {
          clearTimeout(this.isValidTimer)
          clearInterval(this.queryTimer)
          this.isValidTimer = null
          this.qrCodeExpired = true
        }, 60*5*1000)
      }
    },
    sendEmailForModifyPassword(){
      if(!this.sendingAvailable){
        return
      }
      this.sendingAvailable = false
      let formData = new FormData()
      formData.append('email',this.$store.state.email)
      formData.append( 'purpose','modifyPassword')
      this.$axios.post('/userApi/creator/sendEmailCode',formData)
       this.clock = window.setInterval(() => {
        this.countDownNum--;
        this.sendCodeContent = "重新发送（"+this.countDownNum+')'
        if (this.countDownNum < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(this.clock); //关闭
          this.sendingAvailable = true;
          this.countDownNum = 60;
          this.sendCodeContent = "获取验证码"
        }
      }, 1000);
    },
    sendEmailForModifyEmail(){
      if(!this.sendingAvailable){
        return
      }
      this.sendingAvailable = false
      let formData = new FormData()
      formData.append('email',this.$store.state.email)
      formData.append( 'purpose','modifyEmail')
      this.$axios.post('/userApi/creator/sendEmailCode',formData)
      window.clearInterval(this.clock); //关闭
      this.countDownNum = 60;
       this.clock = window.setInterval(() => {
        this.countDownNum--;
        this.sendCodeContent = "重新发送（"+this.countDownNum+')'
        if (this.countDownNum < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(this.clock); //关闭
          this.sendingAvailable = true;
          this.countDownNum = 60;
          this.sendCodeContent = "获取验证码"
        }
      }, 1000);
    },
    sendEmailForModifyEmail2(){
      if(! /.+@.+\..+/.test(this.newEmail)){
        return;
      }

      if(!this.sendingAvailable){
        return
      }
      this.sendingAvailable = false
      let formData = new FormData()
      formData.append('email',this.newEmail)
      formData.append( 'purpose','modifyEmail')
      this.$axios.post('/userApi/creator/sendEmailCode',formData)
      window.clearInterval(this.clock); //关闭
      this.countDownNum = 60;
       this.clock = window.setInterval(() => {
        this.countDownNum--;
        this.sendCodeContent = "重新发送（"+this.countDownNum+')'
        if (this.countDownNum < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(this.clock); //关闭
          this.sendingAvailable = true;
          this.countDownNum = 60;
          this.sendCodeContent = "获取验证码"
        }
      }, 1000);
    },
    verifyEmailCode(){
      this.mailVerifyCodeErrorForModifyPassword = false

      if(this.emailVerifyCode.length<1){
        return;
      }
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      // 验证邮箱验证码
      this.$axios.get('/userApi/creator/checkCode',{
        params:{
          "email":this.$store.state.email,
          "captcha":this.emailVerifyCode,
          "purpose":'modifyPassword'
        }
      }).then(
          (resultData)=>{
            if(resultData.data.code === 200 && resultData.data.data){
              this.changePasswordPage = 2
            }else{
              // 验证码输入错误3次后，弹出图形验证码
              this.mailVerifyCodeErrorForModifyPassword = true
              this.showPicCount = this.showPicCount + 1
              this.picVerifySuccess = false
            }
          }
      )
    },
    verifyEmailCode1ForChangeEmail(){
      this.modifyEmailVerifyCode1Error = false
      // window.clearInterval(this.clock); //关闭
      if(this.modifyEmailVerifyCode1.length < 1){
        return;
      }
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      // 验证邮箱验证码
      this.$axios.get('/userApi/creator/checkCode',{
        params:{
          "email":this.$store.state.email,
          "captcha":this.modifyEmailVerifyCode1,
          "purpose":'modifyEmail'
        }
      }).then(
          (resultData)=>{
            if(resultData.data.code === 200 && resultData.data.data){
              this.sendingAvailable = true;
              this.countDownNum = 60;
              this.sendCodeContent = "获取验证码"
              window.clearInterval(this.clock);
              this.modifyEmailStep = 3
            }else{
              // 验证码输入错误3次后，弹出图形验证码
              this.modifyEmailVerifyCode1Error = true
              this.showPicCount = this.showPicCount + 1
              this.picVerifySuccess = false
            }
          }
      )
    },
    async verifyEmailCode2ForChangeEmail() {
      this.emailOccupied = false
      this.modifyEmailVerifyCode2Error = false

      if (this.modifyEmailVerifyCode2.length < 1) {
        return;
      }
      if (this.showPicCount >= 3 && !this.picVerifySuccess) {
        this.showPicVerify = true
        return
      }
      // let formData = new FormData()
      // formData.append('email', this.newEmail)
      // let response = await this.$axios.post('/userApi/creator/isCreatorExit', formData)
      // if(response.data.code !== 200 || response.data.data){
      //   this.emailOccupied = true
      //   return
      // }

      // 验证邮箱验证码
      this.$axios.get('/userApi/creator/updateEmail', {
        params: {
          "newEmail": this.newEmail,
          "newCaptcha": this.modifyEmailVerifyCode2,
        }
      }).then(
          (resultData) => {
            if (resultData.data.code === 200) {
              this.$store.commit('setEmail',this.newEmail)
              this.closeChangeEmailDialog()
              this.editEmailDialogCtl = false
              this.modifyEmailStep = 1
            } else if(resultData.data.code === 4006){
              // 验证码输入错误3次后，弹出图形验证码
              this.modifyEmailVerifyCode2Error = true
              this.showPicCount = this.showPicCount + 1
              this.picVerifySuccess = false
            } else if(resultData.data.code === 4009){
              this.emailOccupied = true
            }else {
              // 验证码输入错误3次后，弹出图形验证码
              this.modifyEmailVerifyCode2Error = true
              this.showPicCount = this.showPicCount + 1
              this.picVerifySuccess = false
            }
          }
      )
    },
    // 用户通过了验证
    onPicVerifySuccess(msg) {
      this.showPicVerify = false;
      this.showPicCount = 2
      this.picVerifySuccess = true
      // 通过验证后，需要手动隐藏模态框
    },
    // 用户点击遮罩层，应该关闭模态框
    closePicVerify() {
      this.showPicVerify = false;
    },
  },
  mounted(){
    this.getUserInfo()
    if(this.$store.state.appBound){
      this.changePasswordPage = 1
    }else{
      this.changePasswordPage = 4
    }
  }
}
</script>

<style>
  /*裁剪区域样式*/
  #cropper.vue-cropper{
    background:#eeeeee;
    background-image:none !important;
  }
  #cropper .cropper-drag-box {
    background:transparent;
  }

  /*#cropper .cropper-crop-box::after{*/
  /*  content: '';*/
  /*  position: absolute;*/
  /*  width: 100px;*/
  /*  height: 100px;*/
  /*  border-radius: 50%;*/
  /*  top: 20px;*/
  /*  background-color: #e03e2d;*/
  /*}*/
</style>
